import React from 'react';

import TickerIcon from '~/src/components/ticker/icon/TickerIcon';
import Image from '~/src/components/image/Image';

import initPolyglot from '~/src/utilities/libs/polyglot';

import css from './Scoreboard.module.scss';
import i18n from './Scoreboard.i18n.json';

const getTranslation = initPolyglot(i18n);

const goalsListLength = 2;

class Scoreboard extends React.Component {
    renderTeam = (index) => {
        const team = this.props.teams[index],
            image = team && team.image,
            variant = image && image.variants && image.variants.big;

        return (
            <div className={css.scoreboardItem}>
                {team && (
                    <div className={css.scoreboardTeam}>
                        <span className={css.scoreboardTeamName}>{team.name}</span>
                        <div className={css.scoreboardTeamLogo}>{variant && <Image {...team.image} label={team.name} />}</div>
                    </div>
                )}
            </div>
        );
    };

    renderScore = () => {
        const goals = this.props.score.goals;
        const hasGoals = goals && goals.length === goalsListLength;
        return (
            <div className={css.scoreboardRow}>
                {this.renderTeam(0)}
                <div className={css.scoreboardItem}>
                    {hasGoals && (
                        <span>
                            {goals[0]} : {goals[1]}
                        </span>
                    )}
                </div>
                {this.renderTeam(1)}
            </div>
        );
    };

    renderPenaltyShot = (penalty, index) => {
        const penaltyClass = 'scoreboard-penalty-shot ' + (penalty ? 'scoreboard-penalty-goal' : 'scoreboard-penalty-missed'),
            iconPenalty = penalty ? <TickerIcon type={'CheckCircle'} /> : <TickerIcon type={'CancelCircle'} />;

        return (
            <span key={'pen-' + index} className={penaltyClass}>
                {iconPenalty}
            </span>
        );
    };

    renderPenalytyShots = (penalties) => {
        return <div className={css.scoreboardPenaltyShots}>{penalties.map(this.renderPenaltyShot)}</div>;
    };

    renderMoreScores = () => {
        if (this.props.score.penaltyShots) {
            const shots = this.props.score.penaltyShots;
            const hasShots = shots && shots.length === goalsListLength;
            if (hasShots && shots[0].length && shots[1].length) {
                return (
                    <div className={css.scoreboardRow}>
                        <div className={css.scoreboardItem}>{this.renderPenalytyShots(shots[0])}</div>
                        <div className={css.scoreboardItem}>{getTranslation('shootout')}</div>
                        <div className={css.scoreboardItem}>{this.renderPenalytyShots(shots[1])}</div>
                    </div>
                );
            }
        }
        return null;
    };

    render() {
        return (
            <div className={css.scoreboard}>
                {this.renderScore()}
                {this.renderMoreScores()}
            </div>
        );
    }
}

export default Scoreboard;
